<script setup>
import { XIcon } from 'lucide-vue-next'
import { Button, Input } from '@codinglabsau/gooey'
import { useSearch } from '@/Composables/useSearch'

const props = defineProps({
  searchUrl: {
    type: String,
    default: '',
  },
  only: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: 'Search...',
  },
})

const { search, onSearch, clearSearch } = useSearch(props.searchUrl, props.only)
</script>

<template>
  <div
    class="flex items-center justify-end gap-2"
  >
    <div class="relative w-fit max-w-sm items-center">
        <span class="absolute inset-y-0 end-0 flex items-center justify-center px-2">
         <XIcon
           v-if="search && search.length > 0"
           class="size-4 cursor-pointer text-gray-500 hover:text-gray-700"
           @click="clearSearch()"
         />
        </span>

      <Input
        id="search"
        v-model="search"
        type="text"
        :placeholder="placeholder"
        class="border text-sm  text-gray-800 placeholder:text-gray-500 focus:border-muted focus:ring-primary focus-visible:ring-1 focus-visible:ring-primary"
      />
    </div>

    <Button
      variant="outline"
      @click="onSearch()"
    >
      Search
    </Button>
  </div>
</template>
